import React, { useState, useRef } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { MdEdit } from "react-icons/md";
import tw from "tailwind-styled-components";
import {
  InputGroup,
  FieldWrappers,
  Label,
  Wrapper,
  SubmitBtn,
} from "../../Styles/InputStyles";
import SelectFeaturesModal from "../../SelectFeaturesModal";
import { propertyFeatures } from "../../../Config";

const PropertyFeatures = ({
  apiData,
  editInventoryFeaturesMutate,
  editInventoryFeaturesLoading,
}) => {
  const [showFeaturesModal, setShowFeaturesModal] = useState(false);
  const formikRef = useRef(null);

  const validationSchema = Yup.object({
    features: Yup.array().min(1, "Select at least one feature"),
  });

//   const initialValues = {
//   features: apiData?.features
//     ? apiData.features.split(",").map((f) => Number(f))
//     : [],
// };
const initialValues = {
  features: apiData?.features
    ? apiData.features
        .split(",")
        .map((f) => f.trim())
        .filter((f) => f !== "" && !isNaN(Number(f)))
        .map(Number)
    : [],
};

  const handleSubmit = (values) => {
    const payload = {
      inventoryId: apiData?.id,
      features: values.features.join(','),
    };

    editInventoryFeaturesMutate(payload);
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values, setFieldValue, errors, touched }) => {
        const getSelectedLabels = () => {
          if (!values.features?.length) {
            return "Select Features";
          }

          const selected = propertyFeatures.filter((feature) =>
            values.features.includes(feature.value)
          );

          return selected.map((f) => f.label).join(", ");
        };

        const handleFeaturesSelect = (selectedValues) => {
          console.log(selectedValues);
          setFieldValue("features", selectedValues);
        };

        return (
          <Form>
            <Wrapper>
              <InputGroup>
                <Label>Custom Features *</Label>

                <FieldWrappers
                  onClick={() => setShowFeaturesModal(true)}
                  className="border border-gray-400"
                >
                  <Field
                    type="text"
                    readOnly
                    value={getSelectedLabels()}
                    className="w-full border-none outline-none bg-transparent cursor-pointer"
                  />

                  <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                </FieldWrappers>

                {touched.features && errors.features && (
                  <ErrorText>{errors.features}</ErrorText>
                )}
              </InputGroup>

              <BtnWrapper>
                <SubmitBtn
                  type="submit"
                  disabled={editInventoryFeaturesLoading}
                  className="text-sm  w-24  md:w-20 h-7 md:text-xs"
                >
                  {editInventoryFeaturesLoading ? "Updating..." : "Update"}
                </SubmitBtn>
              </BtnWrapper>
            </Wrapper>

            <SelectFeaturesModal
              isOpen={showFeaturesModal}
              onClose={() => setShowFeaturesModal(false)}
              options={propertyFeatures}
              selectedValue={values.features}
              onSelect={handleFeaturesSelect}
              title="Select Features"
              searchPlaceholder="Search Features..."
              width="1/3"
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default PropertyFeatures;

const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
// const SubmitBtn = tw.button`text-sm w-24 md:w-20 h-7 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;
const ErrorText = tw.p`text-rose-600 text-sm mt-1`;
